const tbkAssetPathEnvVar = 'tbkAssetPath';
/**
 * If you stumble upon this and wonder why we didnt use the default getAssetPath from stencil, heres why:
 * It doesnt allow relative paths
 * It doesnt allow setting a default value
 */
/**
 * Changes the default asset path that built-in assets will use.
 *
 * This can either be a relative path, or an absolute path.
 *
 * The setting will be saved in `window.env.tbkAssetPath`
 *
 * @example The default is './assets/', but your apps assets are in '../../assets/', youd call
 * `tbkSetAssetPath("../../assets/")` somewhere near the initialization logic of your app
 *
 * @param assetPath The relative or absolute path to the assets folder.
 */
function tbkSetAssetPath(assetPath) {
    if (window === undefined) {
        console.warn('No window available');
        return;
    }
    // Add trailing slash if it doesnt exist
    const lastChar = assetPath.at(-1);
    if (lastChar != '/') {
        assetPath += '/';
    }
    window['env'] = Object.assign(Object.assign({}, window['env']), { [tbkAssetPathEnvVar]: assetPath });
}
/**
 * Returns the relative path to an asset, either using the default path or a configured asset path.
 * @param asset The asset that should be retrieved, without leading slash.
 */
function tbkGetAssetPath(asset) {
    var _a;
    if (asset.at(0) === '/') {
        asset = asset.slice(1);
    }
    const envAssetPath = (_a = window === null || window === void 0 ? void 0 : window['env']) === null || _a === void 0 ? void 0 : _a[tbkAssetPathEnvVar];
    if (!envAssetPath) {
        return `./assets/${asset}`;
    }
    return `${envAssetPath}${asset}`;
}

export { tbkGetAssetPath as a, tbkSetAssetPath as t };
